/**
 * Куда вести пользователя, отправившего поисковый запрос из шапки.
 *
 * Раньше здесь строился URL с нуля — `/catalog?q=…` — и выбрасывались ВСЕ
 * остальные параметры. Пользователь жаловался ровно на это: «каждый раз когда
 * вбиваю в поисковике "мебель", регион обнуляется».
 *
 * Список именно БЕЛЫЙ, а не «всё кроме»: поиск живёт в шапке и доступен на
 * любой странице, поэтому в текущих параметрах могут лежать чужие ключи
 * (вкладка профиля, utm-метки), которым нечего делать в каталоге.
 *
 * Бюджет (`minBudget`/`maxBudget`) и минус-слова (`exclude`) переносятся:
 * `GET /catalog/search` принимает их с 2026-08-09 (запрос с ними уходит на
 * списочный движок, `SearchService.needsListPath`), и каталог их отправляет.
 * Раньше шапка их выбрасывала, и выдача РАСШИРЯЛАСЬ под надписью «с активными
 * фильтрами»: UZ QA 22.10 — 69 → 330, Liciora QA 26.10 — RM + ≥ $50 M = 37,
 * со словом «servicios» — 79, первым лот на $12,7 M.
 *
 * Что НЕ переносится — намеренно: `sort`, сроки и `since` эндпоинт поиска не
 * принимает (он ранжирует по релевантности). Оставить их в URL значило бы
 * показывать их в интерфейсе активными, пока они не влияют на выдачу. `page`
 * сбрасывается, потому что выдача другая.
 */
const CARRIED_OVER = [
  'region',
  'category',
  'ikpu',
  'niche',
  'status',
  'kind',
  'scope',
  'minBudget',
  'maxBudget',
  'exclude',
] as const;

export function searchTargetPath(query: string, current: URLSearchParams): string {
  const q = query.trim();
  if (!q) return '/catalog';

  const next = new URLSearchParams();
  for (const key of CARRIED_OVER) {
    const value = current.get(key);
    if (value) next.set(key, value);
  }
  next.set('q', q);
  return `/catalog?${next.toString()}`;
}
